import { NmGlowOverlay } from "@/app/(public)/waitlist/_components/nm-glow-overlay";
import { SiteFooter } from "@/app/(public)/_components/site-footer";

type PublicPageShellProps = {
  children: React.ReactNode;
};

/**
 * Shared chrome for public marketing pages: glow, grain, background, footer.
 */
export function PublicPageShell({ children }: PublicPageShellProps) {
  return (
    <>
      <NmGlowOverlay height="40vh" opacity={0.35} />
      <div className="page-grain" aria-hidden />
      <div
        className="fixed inset-0 z-0 bg-cover bg-center"
        style={{ backgroundImage: "url(/bg-blur.jpg)", opacity: 0.15 }}
        aria-hidden
      />
      <div className="relative z-2 flex min-h-screen flex-col">
        {children}
        <SiteFooter />
      </div>
    </>
  );
}
